// extracted by mini-css-extract-plugin
export default {"switch":"Toggle_switch__3-PaS","slider":"Toggle_slider__mkTb2","round":"Toggle_round__mnCwi"};